const BASE_URL = import.meta.env.VITE_IMAGE_BASE_URL || '';

export const getImageUrl = (path: string): string => {
  if (!path || !BASE_URL) return '';
  const encoded = path.split('/').map(segment => encodeURIComponent(segment)).join('/');
  return `${BASE_URL}/${encoded}`;
};
